import { diffLines, diffWordsWithSpace } from "diff";

const splitLines = (value) => {
  const lines = value.split("\n");
  if (lines[lines.length - 1] === "") lines.pop();
  return lines;
};

const plain = (text) => [{ text }];

function wordSegments(oldLine, newLine) {
  const left = [];
  const right = [];
  diffWordsWithSpace(oldLine, newLine).forEach((p) => {
    if (p.added) right.push({ text: p.value, hl: true });
    else if (p.removed) left.push({ text: p.value, hl: true });
    else {
      left.push({ text: p.value });
      right.push({ text: p.value });
    }
  });
  return [left, right];
}

/** Side-by-side rows: same | changed (word-level segments) | removed | added. */
export function buildSideBySide(oldText, newText) {
  const withEol = (t) => (t && !t.endsWith("\n") ? `${t}\n` : t || "");
  const parts = diffLines(withEol(oldText), withEol(newText));
  const rows = [];
  let l = 1;
  let r = 1;
  const push = (type, left, right) => rows.push({
    type,
    left: left && { n: l++, segs: left },
    right: right && { n: r++, segs: right },
  });

  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i];
    if (!part.added && !part.removed) {
      splitLines(part.value).forEach((t) => push("same", plain(t), plain(t)));
    } else if (part.removed && parts[i + 1]?.added) {
      const del = splitLines(part.value);
      const add = splitLines(parts[i + 1].value);
      i += 1;
      for (let k = 0; k < Math.max(del.length, add.length); k += 1) {
        if (del[k] !== undefined && del[k] === add[k]) push("same", plain(del[k]), plain(add[k]));
        else if (del[k] !== undefined && add[k] !== undefined) push("changed", ...wordSegments(del[k], add[k]));
        else if (del[k] !== undefined) push("removed", plain(del[k]), null);
        else push("added", null, plain(add[k]));
      }
    } else if (part.removed) {
      splitLines(part.value).forEach((t) => push("removed", plain(t), null));
    } else {
      splitLines(part.value).forEach((t) => push("added", null, plain(t)));
    }
  }
  return rows;
}

export function diffStats(rows) {
  return rows.reduce((acc, row) => ({
    added: acc.added + (row.type === "added" || row.type === "changed" ? 1 : 0),
    removed: acc.removed + (row.type === "removed" || row.type === "changed" ? 1 : 0),
  }), { added: 0, removed: 0 });
}
